import { render } from "./SimpleBlog.vue?vue&type=template&id=54d98b08&scoped=true"
import script from "./SimpleBlog.vue?vue&type=script&lang=js"
export * from "./SimpleBlog.vue?vue&type=script&lang=js"

import "./SimpleBlog.vue?vue&type=style&index=0&id=54d98b08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\murat\\OneDrive\\mkss\\source\\vuejs\\practiceone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d98b08"]])

export default __exports__